import React from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'

export default function WApp() {
  return (
    <div className="App">
      <FloatingWhatsApp 
        phoneNumber="34664067584"
        accountName="Mana cars"
        statusMessage="Responderemos antes de 24h"
        chatMessage="¿En qué podemos ayudarte?"
        placeholder="Escriba su mensaje..."
        darkMode
        avatar="/img/logo23.webp"
      />
    </div>
  )
}